import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DatePickerCalendarIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.096 20.0288V8.99519H4.904V20.0288H18.096ZM18.096 3.97115C18.6098 3.97115 19.0556 4.17147 19.4333 4.57212C19.8111 4.97276 20 5.44551 20 5.99038V20.0288C20 20.5737 19.8111 21.0385 19.4333 21.4231C19.0556 21.8077 18.6098 22 18.096 22H4.904C4.37511 22 3.92556 21.8077 3.55533 21.4231C3.18511 21.0385 3 20.5737 3 20.0288V5.99038C3 5.44551 3.18511 4.97276 3.55533 4.57212C3.92556 4.17147 4.37511 3.97115 4.904 3.97115H5.83333V2H7.73733V3.97115H15.2627V2H17.1667V3.97115H18.096ZM16.2373 11.0144V12.9856H14.3333V11.0144H16.2373ZM12.4293 11.0144V12.9856H10.5707V11.0144H12.4293ZM8.66667 11.0144V12.9856H6.76267V11.0144H8.66667Z'
                fill='currentColor'
            />
        </>
    ),
})

DatePickerCalendarIcon.displayName = 'DatePickerCalendarIcon'
